import { render, staticRenderFns } from "./AccountProductsForm.vue?vue&type=template&id=6e6cffa2&"
import script from "./AccountProductsForm.vue?vue&type=script&lang=js&"
export * from "./AccountProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports